import { api } from '@/plugins/axios';

export default {
  load,
  switchHotspot,
  resetHotspot,
  setViewYaw,
};

// ////////////////////////////////////////////
function load({ commit, state }, unitTypeId) {
  return api
    .get(`/panorama_native/${unitTypeId}`)
    .then(({ data: { data } }) => {
      commit('setData', data);
      return state.data;
    });
}

function switchHotspot({ commit, getters }, { id, yaw }) {
  const hotspot = getters.findHotspot(id);

  commit('switchHotspot', hotspot);

  if (yaw !== undefined ) {
    commit('setViewYaw', yaw);
  }
}

function resetHotspot({ dispatch, commit, getters }, id) {
  const hotspot = getters.findHotspot(id);


  commit('switchHotspot', hotspot);
  dispatch('setViewYaw', { hotspot });
}

function setViewYaw({ commit, getters }, { hotspot, yaw }) {
  if (yaw === undefined) {
    const predefines = getters.generatePredefines(hotspot);

    yaw = predefines.view.params.yaw
  }

  commit('setViewYaw', yaw);
  setTimeout(() => commit('setViewYaw', undefined))
}
